module.exports = require("swiper/swiper.min.css");